import { gql } from "@apollo/client";

export const START_BOOKING = gql`
  mutation startBooking($id: String!) {
    startBooking(id: $id) {
      id
      dateStarted
      dateReturned
      organisationId
      taxExempted
      tba
      firstInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        rateTypeName
        rateTypeDuration
      }
      currentInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        rateTypeName
        rateTypeDuration
      }
      finalInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
      }
      referenceNumber
      dateCreated
      dateUpdated
      createdBy
      updatedBy {
        id
        firstName
        lastName
      }
      pickupServiceLocation {
        id
        name
        address {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
      }
      pickupOtherLocation {
        street
        city
        state
        country
        zipcode
        fullAddress
      }
      pickupDateTime
      dropoffServiceLocation {
        id
        name
        address {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
      }
      dropoffOtherLocation {
        street
        city
        state
        country
        zipcode
        fullAddress
        location {
          type
          latitude
          longitude
        }
      }
      dropoffDateTime
      longTermBooking
      flightNumber
      insuranceRate
      excess
      customerType
      discount {
        appliedBy
        appliedDate
        isPercent
        code
        amount
      }
      tax {
        appliedBy
        appliedDate
        code
        amount
        payableAmount
      }
      invoices {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        rateTypeName
        rateTypeDuration
      }
      rateTypeName
      rateTypeDuration
      billingCycleName
      billingCycleDuration
      status
      addonRequirements {
        addon {
          id
          name
          category
          imageUrl
          hasFixedRate
          hasQuantity
          fixedRate
          description
          recurringRate {
            rateTypeName
            rateTypeDuration
            rate
            longTerm
          }
          totalQuantity
          availableQuantity
          isActivated
        }
        rate
        quantity
        name
        hasFixedRate
        payableAmount
      }
      customer {
        id
        firstName
        lastName
        email
        phoneNumber {
          phone
          country
        }
        location {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
      }
      currentBookingSchedules {
        id
        startDate
        endDate
        status
        vehicle {
          id
          licencePlate
        }
      }
      businessCustomer {
        id
        businessName
        registrationNumber
        VAT
        registeredAddress {
          street
          city
          state
          zipcode
          country
          fullAddress
        }
        tradingAddressSame
        tradingAddress {
          street
          city
          state
          zipcode
          country
          fullAddress
        }
        approvedDrivers {
          id
          status
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        authorizedSignatories {
          id
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        billing {
          phoneNumber {
            phone
            country
          }
          email
        }
        contact {
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        documents {
          id
          name
          title
          documentType
          expiryDate
          url
        }
      }
      authorizedSignatory
      insurancePolicy {
        id
        name
        description
      }
      paymentDetails {
        startDate
        endDate
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        totalPayableAmount
        rentalTime
      }
    }
  }
`;
